import { render, staticRenderFns } from "./OrderSuccessDialog.vue?vue&type=template&id=dac88c50&scoped=true&"
import script from "./OrderSuccessDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderSuccessDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSuccessDialog.vue?vue&type=style&index=0&id=dac88c50&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac88c50",
  null
  
)

export default component.exports